import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../api/api";
import Sidebar from "../components/Sidebar";
import LatestArticlesSidebar from "../components/LatestArticlesSidebar";
import { SPORT_CONFIG } from "../config/SportConfig";

export default function SportPage() {
    const { sport } = useParams();
    const config = SPORT_CONFIG[sport];


    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        let endpoint = `/api/articles/sport/${sport}`;
        console.log("Sport endpoint:", sport);
        if (sport === "trending") endpoint = "/api/articles/trending";
        if (sport === "breaking") endpoint = "/api/articles/breaking";

        API.get(endpoint)
            .then((res) => {
                setArticles(res.data?.articles || res.data || []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [sport]);


    if (!config) {
        return (
            <div className="py-20 text-center text-gray-600">
                Invalid sport category
            </div>
        );
    }

    if (loading) {
        return (
            <div className="py-20 text-center text-gray-500">
                Loading {sport} news…
            </div>
        );
    }

    if (!articles.length) {
        return (
            <div className="py-20 text-center text-gray-600">
                No {sport} articles available right now.
            </div>
        );
    }

    const [featured, ...rest] = articles;

    return (
        <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 lg:grid-cols-4 gap-10">

            {/* ================= MAIN CONTENT ================= */}
            <div className="lg:col-span-3">

                <h1 className="text-3xl font-extrabold text-gray-900 mb-8">
                    {config.title}
                </h1>

                {/* FEATURED */}
                <Link
                    to={`/article/${featured.slug}`}
                    className="relative block rounded-xl overflow-hidden mb-10 group"
                >
                    <img
                        src={featured.images}
                        alt={featured.title}
                        className="w-full h-[420px] object-cover"
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                    <div className="absolute bottom-6 left-6 right-6 text-white">
                        <span
                            className={`${config.badge} px-3 py-1 rounded-full text-xs font-bold uppercase`}
                        >
                            {config.label}
                        </span>

                        <h2 className="mt-3 text-2xl md:text-3xl font-extrabold">
                            {featured.title}
                        </h2>

                        <p className="mt-2 text-sm text-gray-200 line-clamp-2">
                            {featured.excerpt || "Read full story and latest updates."}
                        </p>
                    </div>
                </Link>

                {/* GRID */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {rest.map((article) => (
                        <Link
                            key={article.slug}
                            to={`/article/${article.slug}`}
                            className="group border rounded-xl overflow-hidden hover:shadow-lg transition"
                        >
                            <img
                                src={article.images}
                                alt={article.title}
                                className="w-full h-48 object-cover"
                            />

                            <div className="p-4">
                                <div className="flex items-center gap-2 mb-2">
                                    <span
                                        className={`${config.badge} text-white text-xs px-2 py-0.5 rounded uppercase`}
                                    >
                                        {config.label}
                                    </span>

                                    <span className="text-xs text-gray-500">
                                        👁 {article.views || 0}
                                    </span>
                                </div>

                                <h3
                                    className={`font-bold text-gray-900 line-clamp-2 ${config.hover}`}
                                >
                                    {article.title}
                                </h3>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            {/* ================= SIDEBAR ================= */}
            <aside className="hidden lg:block space-y-8">
                <div className="sticky top-24 space-y-8">
                    <Sidebar />
                    <LatestArticlesSidebar />
                </div>
            </aside>
        </div>
    );
}
